var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course__edit_links"},[(_vm.requestPending)?[_c('component-loading',{attrs:{"size":'small'}})]:[_c('course-edit-links-form',{attrs:{"is-course":_vm.isRouteCourse,"is-catalog-item":_vm.isRouteCatalogItem}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }